import { ADRESS_STATUS_KEYS, ADRESS_STATUS_LABELS } from './adressStatusLabels'

// AI-CONTEXT: See docs/features/livereport-widgets-housevisits-personas.md
// Shapes the bars for the "huishoudens per status" chart. The dashboard card
// and the live-report widget both render it and used to build this array from
// their own hardcoded five-status list — so a household on 'Onbereikbaar' was
// counted by neither, and the bars quietly stopped adding up to the number of
// households (inbox #121). One builder, driven by ADRESS_STATUS_KEYS.
//
// AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook

/**
 * Oldest Firestore timestamp in a bucket, or null when nothing carries one.
 *
 * @param {Array<{Timestamp?: {toDate: () => Date}}>} items
 * @returns {{toDate: () => Date}|null}
 */
const oldestTimestamp = (items) => {
    const withTimestamp = items.filter(i => i && typeof i.Timestamp?.toDate === 'function')
    if (withTimestamp.length === 0) return null

    return withTimestamp.reduce((oldest, i) =>
        (!oldest || i.Timestamp.toDate() < oldest.Timestamp.toDate()) ? i : oldest
    ).Timestamp
}

/**
 * @typedef {object} HouseVisitsStatusDatum
 * @property {string} name - Visible bar label (e.g. 'Inplannen')
 * @property {string} id - Status key (e.g. 'planning')
 * @property {string} statusId - Status key forwarded to onItemClick
 * @property {{toDate: () => Date}|null} oldestTs - Oldest item in this bucket, for the waiting-days pill
 * @property {{total: number}} value - Bar value
 */

/**
 * @param {Record<string, Array<object>>} [countsByStatus] - Households per status key
 * @returns {Array<HouseVisitsStatusDatum>} One bar per canonical status, in funnel order
 */
const buildStatusChartData = (countsByStatus = {}) =>
    ADRESS_STATUS_KEYS.map((id) => {
        const items = Array.isArray(countsByStatus[id]) ? countsByStatus[id] : []

        return {
            name: ADRESS_STATUS_LABELS[id],
            id,
            statusId: id,
            // Afgerond doesn't have "waiting" urgency, skip the age pill
            oldestTs: id === 'completed' ? null : oldestTimestamp(items),
            value: { total: items.length },
        }
    })

export default buildStatusChartData
